const KeenSlider = window.KeenSlider

const { setInitialised, useArrows, useProgress } = window.BAO.Carousel.plugins

class AlternativeImageCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.slide?.exists) return

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.6,
          spacing: 0
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 3.2,
              spacing: 0
            },
          },
          '(min-width: 901px)': {
            slides: {
              perView: 4.2,
              spacing: 0
            },
          }
        },
      },
      [
        setInitialised(),
        useArrows({
          container: this.els?.arrows?.element,
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
        useProgress({
          container: this.els?.progress?.element,
          progressbar: this.els?.progressbar?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('alternative-image-carousel')) {
  customElements.define('alternative-image-carousel', AlternativeImageCarousel)
}
